<template>
  <div>
    <div class="success-header">
      <h3 class="success-header-subtitle">
        Confirmación de la operación:
      </h3>
      <p>
        Recuerde que la fecha de vencimiento se mantiene para el día <strong>{{ budget.expiration }}</strong>.
      </p>
    </div>
    <div class="success">
      <div>
        <table
          class="tbl mb-0"
          v-if="budget.total"
        >
          <template v-for="(item, i) in budget.items">
            <tr
              v-if="!!item.commissionable && item.total"
              :key="i"
            >
              <td class="text-left">
                {{ item.description }}
              </td>
              <td class="text-right">
                {{ budget.currency + item.total }}
              </td>
            </tr>
          </template>
        </table>
        <table class="tbl mb-0">
          <tr>
            <th
              colspan="6"
              class="txt-right"
            >
              <span class="mr-3">SUBTOTAL</span> {{ budget.currency }}{{ budget.commissionable }}
            </th>
          </tr>
          <template v-for="(item, i) in budget.items">
            <tr
              v-if="!item.commissionable && item.description"
              :key="i"
            >
              <td class="text-left">
                {{ item.description }}
              </td>
              <td class="text-right">
                {{ item.total ? budget.currency + item.total : '- -' }}
              </td>
            </tr>
          </template>
        </table>
        <table class="tbl mb-0">
          <tr>
            <th class="txt-left">
              DESTINO
            </th>
            <th>RESERVA</th>
            <th>CANT. PASAJEROS</th>
            <th>SEÑA</th>
            <th>VENCIMIENTO</th>
            <th class="txt-right">
              <span class="span-violet">TOTAL</span>
            </th>
          </tr>
          <tr>
            <td class="txt-left">
              {{ departure.alias }} {{ departure.name }}
            </td>
            <td>{{ budget.reservation_id }}</td>
            <td>{{ budget.items.passengers.count }}</td>
            <td>{{ budget.currency }}{{ budget.partial }}</td>
            <td>{{ budget.expiration }}</td>
            <td class="txt-right">
              {{ budget.currency }}{{ budget.total }}
            </td>
          </tr>
        </table>
      </div>
      <div class="success-footer mb-3">
        <p class="success-msg">
          Podes realizar el pago de la seña con tarjeta de credito mediante nuestra plataforma de pagos
          online, o bien contactarte con administración por otras formas de pagos.
        </p>
        <btn
          color="white"
          size="xs"
          @click="push"
        >
          CERRAR
        </btn>
        <btn
          color="orange"
          size="xs"
          href="http://cearaevt.tur.ar/shop/variable/"
          target="_blank"
        >
          PAGO ONLINE
        </btn>
        <btn
          color="black"
          size="xs"
          @click="print"
        >
          IMPRIMIR
        </btn>
      </div>
    </div>
  </div>
</template>
<script>
import Btn from '@/components/Btn'
import { yyyymmdd_ddmmyyy } from '@/utils'

export default {
  components: { Btn },

  props: ['reservation'],

  computed: {
    revocation () {
      return this.$store.state.revocation
    },
    budget () {
      return this.$store.state.modify.budget
    },
    departure () {
      return this.$store.state.modify.departure
    }
  },

  methods: {
    push (tab) {
      this.$router.replace({ name: 'reservation_worth', params: this.$route.params })
    },
    print () {
      window.print()
    }
  }
}
</script>
